class DataUtil {
  getGroupAmounts (group) {
    let amounts = {
      estimated: 0,
      actual: 0
    }
    group.items.forEach(item => {
      amounts.estimated += parseInt(item.estimatedAmount)
      amounts.actual += parseInt(item.actualAmount)
    })
    return amounts
  }
  getTotal (groups) {
    let estimated = 0
    let actual = 0
    groups.forEach(group => {
      let amounts = this.getGroupAmounts(group)
      estimated += amounts.estimated
      actual += amounts.actual
    })
    return {
      estimated: estimated,
      actual: actual
    }
  }
  addGroup (groups, itemName) {
    groups.unshift({
      name: itemName,
      items: []
    })
  }
  deleteGroup (groups, index) {
    groups.splice(index, 1)
  }
  addItem (group) {
    group.items.unshift({
      name: '0',
      estimatedAmount: 0,
      actualAmount: 0,
      description: ''
    })
  }
  deleteItem (group, index) {
    group.items.splice(index, 1)
  }
}

export default new DataUtil()



// WEBPACK FOOTER //
// ./src/util/DataUtil.js